import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createTextVNode as _createTextVNode, renderList as _renderList, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "notetaker",
  class: "fnt",
  "aria-labelledby": "fnt-title"
}
const _hoisted_2 = { class: "fnt-head" }
const _hoisted_3 = { class: "fnt-title" }
const _hoisted_4 = { class: "fnt-text" }
const _hoisted_5 = { class: "fnt-list" }
const _hoisted_6 = ["href"]
const _hoisted_7 = {
  key: 0,
  class: "fnt-text"
}
const _hoisted_8 = { class: "fnt-text" }
const _hoisted_9 = { class: "fnt-rule" }
const _hoisted_10 = ["id", "value", "checked", "disabled", "onChange"]
const _hoisted_11 = {
  key: 0,
  class: "fnt-muted"
}
const _hoisted_12 = { class: "fnt-when" }
const _hoisted_13 = { class: "fnt-what" }
const _hoisted_14 = { class: "fnt-name" }
const _hoisted_15 = { class: "fnt-meta" }
const _hoisted_16 = { class: "fnt-err" }
const _hoisted_17 = ["aria-pressed", "disabled", "onClick"]
const _hoisted_18 = { class: "fnt-when" }
const _hoisted_19 = { class: "fnt-what" }
const _hoisted_20 = { class: "fnt-name" }
const _hoisted_21 = { class: "fnt-meta" }
const _hoisted_22 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.state?.available)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _cache[1] || (_cache[1] = _createElementVNode("div", {
              id: "fnt-title",
              class: "fnt-eyebrow"
            }, "Notetaker", -1)),
            _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.state.botName) + " joins your calls and writes the notes", 1)
          ]),
          (_ctx.state.connected)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: _normalizeClass(["fnt-pill", _ctx.state.status == 'connected' ? 'fnt-pill-ok' : 'fnt-pill-warn'])
              }, _toDisplayString(_ctx.state.status == 'connected' ? 'Outlook connected' : 'Reconnect Outlook'), 3))
            : _createCommentVNode("", true)
        ]),
        (_ctx.message)
          ? (_openBlock(), _createElementBlock("p", {
              key: 0,
              class: _normalizeClass(["fnt-msg", 'fnt-msg-' + _ctx.message.tone]),
              role: "status"
            }, _toDisplayString(_ctx.message.text), 3))
          : _createCommentVNode("", true),
        (!_ctx.state.connected)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("p", _hoisted_4, "Connect your Outlook calendar and the " + _toDisplayString(_ctx.state.botName) + " joins your Teams, Zoom and Google Meet calls about 2 minutes before they start. When the call ends, your notes appear in My AI Captures, attached to the Ironbook meeting when the call is one of yours.", 1),
              _createElementVNode("ul", _hoisted_5, [
                _cache[2] || (_cache[2] = _createElementVNode("li", null, "It only reads your calendar. It can't change or send anything.", -1)),
                _cache[3] || (_cache[3] = _createElementVNode("li", null, "People in the call see it, and it posts a message saying it's taking notes.", -1)),
                _createElementVNode("li", null, "The call audio is kept " + _toDisplayString(_ctx.state.audioDays) + " days, then deleted. Notes stay.", 1)
              ]),
              _createElementVNode("a", {
                class: "fnt-btn",
                href: _ctx.api + '/api/ai/notetaker/connect'
              }, "Connect Outlook calendar", 8, _hoisted_6)
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              (!_ctx.state.here)
                ? (_openBlock(), _createElementBlock("p", _hoisted_7, "Your calendar is connected in another company on Ironbook, so its calls go there."))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("p", _hoisted_8, [
                      _cache[4] || (_cache[4] = _createTextVNode("Connected as ", -1)),
                      _createElementVNode("strong", null, _toDisplayString(_ctx.state.email || 'your Outlook account'), 1),
                      _cache[5] || (_cache[5] = _createTextVNode(". ", -1)),
                      (_ctx.state.status != 'connected')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode("Microsoft stopped the connection (a password change can do this). Connect again to keep the notetaker joining.")
                          ], 64))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("fieldset", _hoisted_9, [
                      _cache[6] || (_cache[6] = _createElementVNode("legend", null, "Which calls should it join?", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rules, (r) => {
                        return (_openBlock(), _createElementBlock("label", {
                          key: r.value,
                          class: "fnt-radio"
                        }, [
                          _createElementVNode("input", {
                            id: 'fnt-rule-' + r.value,
                            type: "radio",
                            name: "fnt-rule",
                            value: r.value,
                            checked: _ctx.state.joinRule == r.value,
                            disabled: _ctx.busy,
                            onChange: ($event: any) => (_ctx.setRule(r.value))
                          }, null, 40, _hoisted_10),
                          _createElementVNode("span", null, _toDisplayString(r.label), 1)
                        ]))
                      }), 128))
                    ]),
                    _cache[10] || (_cache[10] = _createElementVNode("div", { class: "fnt-sub" }, "Next 14 days", -1)),
                    (!_ctx.state.upcoming.length)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_11, "No calls with a meeting link on your calendar yet. New invites show up here within a few minutes."))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.upcoming, (e) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: e.id,
                        class: "fnt-row"
                      }, [
                        _createElementVNode("div", _hoisted_12, [
                          _createTextVNode(_toDisplayString(_ctx.day(e.start)), 1),
                          _createElementVNode("span", null, _toDisplayString(_ctx.time(e.start)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("div", _hoisted_14, _toDisplayString(e.title), 1),
                          _createElementVNode("div", _hoisted_15, [
                            _createTextVNode(_toDisplayString(_ctx.platformName(e.platform)), 1),
                            (e.error)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _cache[7] || (_cache[7] = _createTextVNode(" · ", -1)),
                                  _createElementVNode("span", _hoisted_16, _toDisplayString(e.error), 1)
                                ], 64))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("button", {
                          type: "button",
                          class: _normalizeClass(["fnt-toggle", { on: e.joining }]),
                          "aria-pressed": e.joining,
                          disabled: _ctx.busy,
                          onClick: ($event: any) => (_ctx.toggle(e))
                        }, _toDisplayString(e.joining ? 'Notetaker on' : 'Notetaker off'), 11, _hoisted_17)
                      ]))
                    }), 128)),
                    (_ctx.state.recent.length)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _cache[9] || (_cache[9] = _createElementVNode("div", { class: "fnt-sub" }, "Recent calls", -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.recent, (e) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: 'r' + e.id,
                              class: "fnt-row"
                            }, [
                              _createElementVNode("div", _hoisted_18, [
                                _createTextVNode(_toDisplayString(_ctx.day(e.start)), 1),
                                _createElementVNode("span", null, _toDisplayString(_ctx.time(e.start)), 1)
                              ]),
                              _createElementVNode("div", _hoisted_19, [
                                _createElementVNode("div", _hoisted_20, _toDisplayString(e.title), 1),
                                _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.recentStatus(e)), 1)
                              ]),
                              (e.jobId)
                                ? (_openBlock(), _createBlock(_component_router_link, {
                                    key: 0,
                                    class: "fnt-open",
                                    to: '/ai-review/' + e.jobId
                                  }, {
                                    default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                                      _createTextVNode("Open notes", -1)
                                    ]))]),
                                    _: 1
                                  }, 8, ["to"]))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ], 64))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      type: "button",
                      class: "fnt-link",
                      disabled: _ctx.busy,
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.disconnect && _ctx.disconnect(...args)))
                    }, "Disconnect Outlook", 8, _hoisted_22)
                  ], 64))
            ], 64))
      ]))
    : _createCommentVNode("", true)
}